import styled from "styled-components";
import { ReactComponent as AcceptTermsSVG } from '../../assets/images/accept-terms.svg';
import { userReducer } from "@tiffin/app-common";
import { useAppDispatch } from "../../hooks";
import { Button, Modal } from "antd";

export const UnacknowledgedModal = styled(BaseUnacknowledgedModal)`
  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    padding: 40px 10px;

    .inner-content {
      display: flex;
      flex-direction: column;
      gap: 20px;
      flex-grow: 1;
    }
    
    svg {
      width: 100px;
      height: fit-content;
    }

    .internal-link {
      padding: 0;
      height: auto;
    }
  }
`

interface IUnacknowledgedModal {
  className?: string
  open: boolean,
  tcCustomerVersion: number
}

function BaseUnacknowledgedModal({className, open, tcCustomerVersion}: IUnacknowledgedModal) {
  
  const dispatch = useAppDispatch()

  function handleAccept() {
    if(tcCustomerVersion !== undefined) {
      dispatch(userReducer.updatePolicyAck({
        type: "customer",
        version: tcCustomerVersion
      }))
    }
  }

  return (
    <Modal
      className={className}
      open={open}
      okText="Accept"
      title="Update to our terms"
      footer={[
        <Button type="primary" onClick={handleAccept}>
          Accept
        </Button>
      ]}
      destroyOnClose={true}
      closable={false}
    >
      <div className="content">
        <AcceptTermsSVG />
        <div className="inner-content">
          <div>
            We've updated our Terms and Conditions. Please accept to continue to use Tifyn.
          </div>
          <div>
            By tapping Accept, you agree to the new <Button className="internal-link" type="link" href="https://tifyn.com.au/customer-terms-and-conditions.html">Terms</Button> and <Button className="internal-link" type="link" href="https://tifyn.com.au/privacy-policy.html">Privacy Policy</Button> of Tifyn.
          </div>
        </div>
      </div>
    </Modal>
  )
}